import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import {useHistory} from 'react-router-dom';
import * as actions from '../../_redux/actions/OrdersPageTableActions';
import * as columnFormatters from '../../../_common/column-formatters';
import * as customColumnFormatters from '../column-formatters';
import {useOrdersPageUIContext} from '../OrdersPageUIContext';
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from '../../../_common/components/CommonGrid';
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';
import SortingColumnHeader from "../../../_common/components/SortingColumnHeader/SortingColumnHeader";

export function OrdersPageTable() {
  const intl = useIntl();
  const history = useHistory();
  const prefix = 'orders-page-column';
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'orderNumber',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-orderNumber`, defaultMessage: 'Order number'})}
          fieldName={'orderNumber'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'createdDate',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-createdDate`, defaultMessage: 'Created date'})}
          fieldName={'createdDate'}
          useContext={useOrdersPageUIContext}
          showDefaultIcon={true}
        />
    },
    {
      accessor: 'customers',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-customers`, defaultMessage: 'Customers'})}
          fieldName={'customers'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'shumaCount',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-shumaCount`, defaultMessage: 'Shuma count'})}
          fieldName={'shumaCount'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'dueDate',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'})}
          fieldName={'dueDate'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'status',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
          fieldName={'status'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'paid',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-paid`, defaultMessage: 'Paid'})}
          fieldName={'paid'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'totalPayment',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-totalPayment`, defaultMessage: 'Total payment'})}
          fieldName={'totalPayment'}
          useContext={useOrdersPageUIContext}
        />
    },
    {
      accessor: 'actions',
      Header: '',
      width: 90
    },
  ], []);

  const data = useMemo(() => [
    ...tableRows.map((item) => {
    return {
      orderNumber: columnFormatters.BoldColumnFormatter(item.orderNumber, 'xl'),
      createdDate: columnFormatters.DateColumnFormatter(item.createdDate),
      customers: columnFormatters.SeveralItemsNoRepeatColumnFormatter(item.customers),
      shumaCount: columnFormatters.BoldColumnFormatter(item.shumaCount),
      dueDate: columnFormatters.DateColumnFormatter(item.dueDate),
      status: columnFormatters.OrderStatusColumnFormatter(item.status),
      paid: columnFormatters.OrderPaidColumnFormatter(item, true),
      totalPayment: columnFormatters.OrderTotalPaymentColumnFormatter(item),
      actions: customColumnFormatters.OrdersActionsColumnFormatter(item, {history}),
    };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'ordersPageTableReducer',
    UIContext: useOrdersPageUIContext(),
    getNewEntities: actions.getOrders,
    getNextEntities: actions.getNextOrders,
    onEntitiesChange: entities => {
      entities
        ? setTableRows(entities)
        : setTableRows([]);
    },
    startRequestedPageNumber: 0,
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (<CommonGridSpinner/>),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      {...useTable({columns, data})}
    />
  );
}

export default OrdersPageTable;
